import { render, staticRenderFns } from "./markdown-renderer.vue?vue&type=template&id=3d6019fc"
import script from "./markdown-renderer.vue?vue&type=script&lang=ts"
export * from "./markdown-renderer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports